import React from "react"
import gql from "graphql-tag"
import PropTypes from "prop-types"
import authentication from "@irati/auth"

import {Query} from "../"
import report from "../../gql/report"

const DEFAULT_PAGE_SIZE = 6

export const query = gql`
  query Reports($params: ListReportsParams!) {
    reports(params: $params) {
      total
      count
      offset
      results {
        ${report}
      }
    }
  }`

export const defaultParams = {
  orderBy: "createdAt",
  orderDirection: "DESC",
  offset: 0,
  limit: DEFAULT_PAGE_SIZE
}

const ReportsQuery = ({children, variables: {params: newParams}, ...props}) => {
  const params = {
    tenantUuid: authentication.userTenant().uuid,
    userUuid: authentication.user().uuid,
    ...defaultParams,
    ...newParams
  }
  return (
    <Query
      {...props}
      variables={{params}}
      fetchPolicy="network-only"
      query={query}>
      {({data: {reports = []}, ...apolloState}) => {
        return children({reports, ...apolloState})
      }}
    </Query>
  )
}

ReportsQuery.propTypes = {
  children: PropTypes.func.isRequired,
  variables: PropTypes.shape({
    params: PropTypes.object.isRequired
  }).isRequired
}


export default ReportsQuery
